/* global angular */

'use strict';

(function () {

  angular
    .module('specsguardApp')
    .config(AccountConfig);

  AccountConfig.$inject = ['$stateProvider'];

  function AccountConfig ($stateProvider) {

    $stateProvider
      .state('login', {
        url: '/',
        templateUrl: 'app-legacy/account/login/login.html',
        controller: 'LoginCtrl',
        menu: {},
        data: {
          hideMenu: true,
        }
      })
      .state('settings', {
        url: '/settings',
        templateUrl: 'app-legacy/account/settings/settings.html',
        controller: 'SettingsCtrl',
        menu: {},
        authenticate: true
      })
      .state('activate', {
        url: '/user/activate/:userId/:activationToken',
        templateUrl: 'app-legacy/account/activate/activate.html',
        menu: {},
        data: {
          hideMenu: true,
        },
        controller: 'AccountActivateCtrl'
      })
      .state('logout', {
        url: '/logout',
        template: '<h1></h1>',
        controller: 'logOutCtrl',
        menu: {},
        data: {
          hideMenu: true,
        }
      });
  }

})();
